const PERSONAL_INFO = 'PERSONAL_INFO';
const CONTRACT_FOUND_NOT_NUM = 'CONTRACT_FOUND_NOT_NUM';
const CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND';
const VERIFY_IDENTITY = 'VERIFY_IDENTITY';
const AUTH_BY_CONTRACT = 'AUTH_BY_CONTRACT';
const AUTH_BY_CONTRACT_SUCCESS = 'AUTH_BY_CONTRACT_SUCCESS';
const AUTH_BY_CONTRACT_EPARGN_SUCCESS = 'AUTH_BY_CONTRACT_EPARGN_SUCCESS';
const AUTH_BY_CONTRACT_EPARGN_SMS = 'AUTH_BY_CONTRACT_EPARGN_SMS';
const AUTH_BY_CONTRACT_EPARGN_EMAIL = 'AUTH_BY_CONTRACT_EPARGN_EMAIL';
const AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT =
  'AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT';
const AUTH_BY_CONTRACT_EPARGN_FAILED = 'AUTH_BY_CONTRACT_EPARGN_FAILED';
const AUTH_BY_CONTRACT_FAILED = 'AUTH_BY_CONTRACT_FAILED';
const ID_MEMO = 'ID_MEMO';
const CREATE_PASSWORD = 'CREATE_PASSWORD';
const AUTH_BY_SMS = 'AUTH_BY_SMS';
const AUTH_EPARGN_SMS_UNVALID_USER = 'AUTH_EPARGN_SMS_UNVALID_USER';
const SEND_EMAIL_VERIFICATION_UNVALID_USER =
  'SEND_EMAIL_VERIFICATION_UNVALID_USER';
const VERIFY_EMAIL_EPARGN_UNVALID_USER = 'VERIFY_EMAIL_EPARGN_UNVALID_USER';
const ID_MEMO_EPARGN_UNVALID_USER = 'ID_MEMO_EPARGN_UNVALID_USER';
const CREATE_PASSWORD_EPARGN_UNVALID_USER =
  'CREATE_PASSWORD_EPARGN_UNVALID_USER';
const ACCOUNT_LOCKED = 'Account locked';

const signupStepsList = [
  {
    name: PERSONAL_INFO,
    label: 'personalInfo',
    index: 0,
  },
  {
    name: AUTH_BY_SMS,
    label: 'validation',
    index: 1,
  },
  {
    name: CONTRACT_FOUND_NOT_NUM,
    label: 'validation',
    index: 1,
  },
  {
    name: CONTRACT_NOT_FOUND,
    label: 'validation',
    index: 1,
  },
  {
    name: VERIFY_IDENTITY,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_SUCCESS,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_EPARGN_SUCCESS,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_EPARGN_SMS,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_EPARGN_EMAIL,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_EPARGN_FAILED,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_BY_CONTRACT_FAILED,
    label: 'validation',
    index: 1,
  },
  {
    name: AUTH_EPARGN_SMS_UNVALID_USER,
    label: 'validation',
    index: 1,
  },
  {
    name: SEND_EMAIL_VERIFICATION_UNVALID_USER,
    label: 'validation',
    index: 1,
  },
  {
    name: VERIFY_EMAIL_EPARGN_UNVALID_USER,
    label: 'validation',
    index: 1,
  },
  {
    name: ID_MEMO,
    label: 'idAndPassword',
    index: 2,
  },
  {
    name: ID_MEMO_EPARGN_UNVALID_USER,
    label: 'idAndPassword',
    index: 2,
  },
  {
    name: CREATE_PASSWORD,
    label: 'idAndPassword',
    index: 2,
  },
  {
    name: CREATE_PASSWORD_EPARGN_UNVALID_USER,
    label: 'idAndPassword',
    index: 2,
  },
];

export {
  PERSONAL_INFO,
  CONTRACT_FOUND_NOT_NUM,
  CONTRACT_NOT_FOUND,
  AUTH_BY_CONTRACT,
  AUTH_BY_CONTRACT_SUCCESS,
  AUTH_BY_CONTRACT_EPARGN_SUCCESS,
  AUTH_BY_CONTRACT_EPARGN_SMS,
  AUTH_BY_CONTRACT_EPARGN_EMAIL,
  AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT,
  AUTH_BY_CONTRACT_EPARGN_FAILED,
  AUTH_BY_CONTRACT_FAILED,
  ID_MEMO,
  CREATE_PASSWORD,
  signupStepsList,
  AUTH_BY_SMS,
  VERIFY_IDENTITY,
  AUTH_EPARGN_SMS_UNVALID_USER,
  SEND_EMAIL_VERIFICATION_UNVALID_USER,
  ID_MEMO_EPARGN_UNVALID_USER,
  VERIFY_EMAIL_EPARGN_UNVALID_USER,
  CREATE_PASSWORD_EPARGN_UNVALID_USER,
  ACCOUNT_LOCKED,
};
